import { useEffect, useRef } from "react";
import type { BattleLogEvent, CombatHapticsConfig } from "../types";
import { playSkillHaptic } from "../utils/haptics";
import { hapticImpact } from "../utils/telegram";

const PLAYER_OFFENSIVE_ACTIONS = new Set(["ATTACK", "AOE"]);

function playerTookDamage(ev: BattleLogEvent): boolean {
  if (ev.action === "ATTACK") {
    if (ev.multi_hit && ev.hits?.some((h) => h.target.startsWith("player") && h.damage)) return true;
    if (ev.target?.startsWith("player") && ev.damage) return true;
  }
  if (ev.action === "AOE" && ev.hits?.some((h) => h.target.startsWith("player") && h.damage)) {
    return true;
  }
  return false;
}

/** Fires Telegram haptics for player attacks and hits taken by the hero. */
export function useBattleHaptics(
  visibleLog: BattleLogEvent[],
  haptics: CombatHapticsConfig | null | undefined,
) {
  const prevLenRef = useRef(0);

  useEffect(() => {
    const newEvents = visibleLog.slice(prevLenRef.current);
    prevLenRef.current = visibleLog.length;
    if (!newEvents.length || !haptics) return;

    for (const ev of newEvents) {
      if (ev.actor.startsWith("player") && ev.skill && PLAYER_OFFENSIVE_ACTIONS.has(ev.action)) {
        void playSkillHaptic(ev.skill, haptics);
      }

      const hitCfg = haptics.on_player_hit;
      if (hitCfg?.enabled && playerTookDamage(ev)) {
        hapticImpact(hitCfg.impact ?? "medium");
      }
    }
  }, [visibleLog, haptics]);
}
